import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";
const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="bfr-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">Your Partner in Secure Innovation</h4>
          <p className="contact_investers_para">
            At Soori Corporation, we’re not just a provider; we’re your ally in
            transforming visions into reality. By blending cutting-edge
            biometric technology with industry insights, we create solutions
            that enhance security and drive your business forward.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Enhance Security Now
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
